import React from 'react'
import PropTypes from 'prop-types'
import { DEFAULT_USER_NAME_I18N_ID } from 'src/services'
import { LocalizedText } from 'labguard-cdk'

const LocalizedUserName = ({ id, values, ...other }) => <LocalizedText id={id} values={values} {...other} />

LocalizedUserName.defaultProps = {
  id: DEFAULT_USER_NAME_I18N_ID,
}

LocalizedUserName.propTypes = {
  id: PropTypes.string,
  values: PropTypes.shape({
    firstname: PropTypes.string.isRequired,
    lastname: PropTypes.string.isRequired,
  }).isRequired,
}

export default LocalizedUserName
